export default __webpack_public_path__ + "static/media/Search.c549ce97.svg";